export default __webpack_public_path__ + "static/media/makerChecker.e061bc18.svg";